module.exports = __webpack_public_path__ + "img/customer_zgzt.3ebde770.svg";